/**
 * Milk-It Details Modal
 * Lightweight modal injected at runtime. No Liquid markup required.
 */
(function(){
  'use strict';

  var SELECTOR_TRIGGER = '.milkit-details-trigger';
  var FILTER_SELECTOR_TRIGGER = '.milkit-filter-details-trigger';
  var MODAL_ID = 'milkit-details-modal';
  var FILTER_MODAL_ID = 'milkit-filter-details-modal';
  
  function createLazyImageElement() {
    try {
      return document.createElement('img', { is: 'lazy-image' });
    } catch (e) {
      var img = document.createElement('img');
      try { img.setAttribute('is', 'lazy-image'); } catch (e2) { /* no-op */ }
      return img;
    }
  }
  
  function wireThemeLoading(wrapper, img) {
    if (!wrapper || !img) return;
    wrapper.setAttribute('loading', 'true');
    var done = function(){ wrapper.removeAttribute('loading'); };
    if (img.complete) return done();
    img.addEventListener('load', function(){
      if (window.requestIdleCallback) window.requestIdleCallback(done, { timeout: 150 });
      else setTimeout(done, 0);
    }, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function ensureModal() {
    if (document.getElementById(MODAL_ID)) return;

    var translations = (window.milkitTranslations || {});
    
    var ariaLabelText = translations.modalHeading || translations.details || '';
    var ctaText = translations.detailsCta || '';
    var closeLabel = translations.close || '';

    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', ariaLabelText);
    modal.style.position = 'fixed';
    modal.style.inset = '0';
    modal.style.background = 'rgba(0,0,0,0.75)';
    modal.style.backdropFilter = 'blur(2px)';
    modal.style.display = 'none';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    modal.style.zIndex = '99999';

    var card = document.createElement('div');
    card.style.background = '#FFFFFF';
    card.style.borderRadius = '16px';
    card.style.width = 'min(520px, 92vw)';
    card.style.maxHeight = '80vh';
    card.style.overflow = 'hidden';
    card.style.boxShadow = '0 20px 60px rgba(0,0,0,0.3)';
    card.style.transform = 'translateY(20px) scale(0.95)';
    card.style.opacity = '0';
    card.style.transition = 'transform .35s cubic-bezier(0.19,1,0.22,1), opacity .35s ease';
    card.style.position = 'relative';

    // Remove header block to eliminate top empty space and divider line
    var header = document.createElement('div');
    header.style.display = 'none';

    var hTitle = document.createElement('div');
    hTitle.id = MODAL_ID + '-title';
    // Title intentionally hidden per request
    hTitle.style.display = 'none';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.textContent = '×';
    closeBtn.style.border = 'none';
    closeBtn.style.background = 'rgba(0,0,0,0.04)';
    closeBtn.style.width = '32px';
    closeBtn.style.height = '32px';
    closeBtn.style.borderRadius = '50%';
    closeBtn.style.fontSize = '20px';
    closeBtn.style.cursor = 'pointer';
    closeBtn.style.transition = 'all 0.2s';
    closeBtn.style.color = 'rgba(0,0,0,0.5)';
    closeBtn.style.display = 'flex';
    closeBtn.style.alignItems = 'center';
    closeBtn.style.justifyContent = 'center';
    closeBtn.style.lineHeight = '1';
    closeBtn.style.position = 'absolute';
    closeBtn.style.top = '12px';
    closeBtn.style.right = '12px';
    closeBtn.style.zIndex = '2';

    var body = document.createElement('div');
    body.style.padding = '20px 24px 36px';
    body.style.fontSize = '15px';
    body.style.lineHeight = '1.6';
    body.style.color = 'rgba(0,0,0,0.8)';
    body.style.maxHeight = 'calc(80vh - 0px)';
    body.style.overflowY = 'auto';

    // Removed top deal badge per request

    // Removed tagline ("no-brainer") per request

    // 1:1 content from EcoSeal upsell section (heading, badge line, checklist)
    var upsellHeadingText = translations.modalHeading || '';
    var upsellBadgeText = translations.modalBadge || '';

    var upsellHeading = document.createElement('h2');
    upsellHeading.textContent = upsellHeadingText;
    upsellHeading.style.margin = '18px 0 6px';
    upsellHeading.style.fontSize = '22px';
    upsellHeading.style.lineHeight = '1.25';
    upsellHeading.style.textAlign = 'center';
    upsellHeading.style.color = '#000';
    upsellHeading.style.fontWeight = '800';
    body.appendChild(upsellHeading);

    var upsellBadgeLine = document.createElement('div');
    upsellBadgeLine.textContent = upsellBadgeText;
    upsellBadgeLine.style.margin = '0 auto 14px';
    upsellBadgeLine.style.textAlign = 'center';
    upsellBadgeLine.style.fontWeight = '600';
    upsellBadgeLine.style.fontSize = '14px';
    upsellBadgeLine.style.color = 'rgba(0,0,0,0.7)';
    body.appendChild(upsellBadgeLine);

    // Feature grid (equal width cards)
    var features = document.createElement('div');
    features.style.display = 'grid';
    features.style.gridTemplateColumns = 'repeat(auto-fit, minmax(220px, 1fr))';
    features.style.gap = '10px';
    features.style.margin = '12px 0 16px';

    function addCard(text){
      // Unescape HTML entities
      var unescapedText = text.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
      
      var card = document.createElement('div');
      card.style.display = 'flex';
      card.style.alignItems = 'center';
      card.style.gap = '10px';
      card.style.background = '#FFFFFF';
      card.style.border = '1px solid rgba(0,0,0,0.08)';
      card.style.borderRadius = '12px';
      card.style.padding = '12px 14px';
      card.style.minHeight = '44px';
      card.style.boxShadow = '0 1px 2px rgba(0,0,0,0.04)';
      card.style.wordBreak = 'break-word';
      var tick = document.createElement('span');
      tick.textContent = '✓';
      tick.style.color = '#2E7D32';
      tick.style.fontWeight = '700';
      var txt = document.createElement('span');
      txt.textContent = unescapedText;
      txt.style.fontSize = '14px';
      txt.style.lineHeight = '1.4';
      txt.style.color = 'rgba(0,0,0,0.85)';
      card.appendChild(tick);
      card.appendChild(txt);
      features.appendChild(card);
    }

    addCard(translations.modalChip1 || '');
    addCard(translations.modalChip2 || '');
    addCard(translations.modalChip3 || '');
    body.appendChild(features);

    // Intro highlight removed (content moved to upsell translations)

    // Visuals (images)
    var visuals = document.createElement('div');
    visuals.style.display = 'flex';
    visuals.style.alignItems = 'center';
    visuals.style.justifyContent = 'center';
    var isMobileViewport = window.innerWidth <= 480;
    visuals.style.gap = isMobileViewport ? '16px' : '24px';
    visuals.style.margin = '12px 0 20px';
    visuals.style.padding = '12px 0';

    var milkImgUrl = (window.milkitAssets && (window.milkitAssets.detailsMilkImage || window.milkitAssets.milkImage)) || 'milk_it.webp';
    var sealerImgUrl = (window.milkitAssets && (window.milkitAssets.detailsSealerImage || window.milkitAssets.sealerImage)) || 'Vacuum_Sealer_B.webp';

    var imgSize = isMobileViewport ? 130 : 200;

    function createVisual(src, alt){
      var wrap = document.createElement('div');
      wrap.className = 'media-wrapper media-wrapper--small';
      wrap.style.width = imgSize + 'px';
      wrap.style.height = imgSize + 'px';
      wrap.style.borderRadius = '12px';
      wrap.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)';
      wrap.style.maxWidth = imgSize + 'px';
      wrap.style.maxHeight = imgSize + 'px';
      
      var img = createLazyImageElement();
      img.src = src;
      img.alt = alt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = imgSize;
      img.height = imgSize;
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      wrap.appendChild(img);
      wireThemeLoading(wrap, img);
      return wrap;
    }

    visuals.appendChild(createVisual(milkImgUrl, 'Milk it!'));
    var plus = document.createElement('div');
    plus.textContent = '+';
    plus.style.fontSize = isMobileViewport ? '24px' : '28px';
    plus.style.fontWeight = '300';
    plus.style.opacity = '0.5';
    visuals.appendChild(plus);
    visuals.appendChild(createVisual(sealerImgUrl, 'EcoSeal Pro'));
    body.appendChild(visuals);

    // Second bullet list removed (merged into chips)

    // Combined beyond + pro tip footer
    var footer = document.createElement('div');
    footer.style.marginTop = '24px';
    footer.style.padding = '20px 24px';
    footer.style.background = 'rgba(0,0,0,0.04)';
    footer.style.border = '1px solid rgba(0,0,0,0.1)';
    footer.style.borderRadius = '16px';
    footer.style.fontSize = '14px';
    footer.style.color = 'rgba(0,0,0,0.8)';
    footer.style.textAlign = 'center';
    footer.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';

    var footerTitleText = translations.modalFooterTitle || '';
    var footerTitle = document.createElement('div');
    footerTitle.textContent = '✨ ' + footerTitleText;
    footerTitle.style.fontWeight = '800';
    footerTitle.style.color = '#000';
    footerTitle.style.fontSize = '15px';
    footerTitle.style.marginBottom = '8px';

    var footerMainText = translations.modalFooterText || '';
    var footerDesc = document.createElement('div');
    footerDesc.textContent = footerMainText;
    footerDesc.style.lineHeight = '1.6';
    footerDesc.style.marginBottom = '12px';

    var footerTipText = translations.modalFooterTip || '';
    var footerLinkText = translations.modalFooterLink || '';
    var footerTip = document.createElement('div');
    footerTip.style.fontSize = '13px';
    footerTip.style.color = 'rgba(0,0,0,0.7)';
    footerTip.style.lineHeight = '1.5';
    
    if (footerTipText && footerLinkText && translations.ecosealUrl) {
      var footerLink = document.createElement('a');
      footerLink.href = translations.ecosealUrl;
      footerLink.style.fontWeight = '600';
      footerLink.style.color = '#000';
      footerLink.style.textDecoration = 'underline';
      footerLink.textContent = footerLinkText;
      footerTip.appendChild(document.createTextNode(footerTipText + ' '));
      footerTip.appendChild(document.createTextNode('👉 '));
      footerTip.appendChild(footerLink);
    } else if (footerTipText) {
      footerTip.textContent = footerTipText;
    }

    footer.appendChild(footerTitle);
    if (footerMainText) footer.appendChild(footerDesc);
    if (footerTipText) footer.appendChild(footerTip);
    body.appendChild(footer);

    // CTA row
    var ctaRow = document.createElement('div');
    ctaRow.style.display = 'flex';
    ctaRow.style.flexDirection = 'column';
    ctaRow.style.gap = '12px';
    ctaRow.style.alignItems = 'center';
    ctaRow.style.marginTop = '28px';

    var ctaBtn = document.createElement('button');
    ctaBtn.type = 'button';
    ctaBtn.textContent = ctaText;
    ctaBtn.style.background = '#000';
    ctaBtn.style.color = '#fff';
    ctaBtn.style.border = 'none';
    ctaBtn.style.borderRadius = '8px';
    ctaBtn.style.padding = '14px 24px';
    ctaBtn.style.fontWeight = '700';
    ctaBtn.style.fontSize = '15px';
    ctaBtn.style.cursor = 'pointer';
    ctaBtn.style.width = '100%';
    ctaBtn.style.maxWidth = '280px';
    ctaBtn.style.transition = 'transform 0.2s, box-shadow 0.2s';
    
    ctaBtn.addEventListener('mouseenter', function(){ 
      ctaBtn.style.transform = 'translateY(-1px)';
      ctaBtn.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
    });
    ctaBtn.addEventListener('mouseleave', function(){ 
      ctaBtn.style.transform = 'translateY(0)';
      ctaBtn.style.boxShadow = 'none';
    });

    // Primary action: select EcoSeal Pro set, trigger variant change, close modal
    ctaBtn.addEventListener('click', function(){
      try {
        var checkbox = document.getElementById('milkit-ecopro-checkbox');
        if (checkbox) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (window.MilkItVariantManager && typeof window.MilkItVariantManager.updateVariantBySku === 'function') {
          window.MilkItVariantManager.updateVariantBySku('milk_it_ecopro_set');
        }
      } catch (e) { /* no-op */ }
      close();
    });

    ctaRow.appendChild(ctaBtn);
    body.appendChild(ctaRow);

    // Removed separate hint row (merged above)

    // Place close button at top-right of the card
    card.appendChild(closeBtn);
    card.appendChild(body);
    modal.appendChild(card);
    document.body.appendChild(modal);

    // Add gradient accent to card
    var accent = document.createElement('div');
    accent.style.position = 'absolute';
    accent.style.top = '0';
    accent.style.right = '0';
    accent.style.width = '200px';
    accent.style.height = '200px';
    accent.style.background = 'radial-gradient(circle at top right, rgba(187, 255, 0, 0.08), transparent 70%)';
    accent.style.pointerEvents = 'none';
    accent.style.borderRadius = '0 16px 0 0';
    card.appendChild(accent);

    // Add hover effect to close button
    closeBtn.addEventListener('mouseenter', function(){
      closeBtn.style.background = 'rgba(0,0,0,0.08)';
      closeBtn.style.color = 'rgba(0,0,0,0.8)';
    });
    closeBtn.addEventListener('mouseleave', function(){
      closeBtn.style.background = 'rgba(0,0,0,0.04)';
      closeBtn.style.color = 'rgba(0,0,0,0.5)';
    });

    function open() {
      modal.style.display = 'flex';
      requestAnimationFrame(function(){
        card.style.transform = 'translateY(0) scale(1)';
        card.style.opacity = '1';
      });
      document.body.style.overflow = 'hidden';
      var trigger = document.querySelector(SELECTOR_TRIGGER);
      if (trigger) trigger.setAttribute('aria-expanded','true');
    }

    function close() {
      card.style.transform = 'translateY(20px) scale(0.95)';
      card.style.opacity = '0';
      setTimeout(function(){
        modal.style.display = 'none';
        document.body.style.overflow = '';
        var trigger = document.querySelector(SELECTOR_TRIGGER);
        if (trigger) trigger.setAttribute('aria-expanded','false');
      }, 300);
    }

    // Expose for other scripts (optional)
    window.milkitDetailsModal = { open: open, close: close };

    // Listeners
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if (e.target === modal) close(); });

    // Keyboard
    document.addEventListener('keydown', function(e){
      if (modal.style.display !== 'flex') return;
      if (e.key === 'Escape') close();
    });
  }

  function ensureFilterModal() {
    if (document.getElementById(FILTER_MODAL_ID)) return;

    var t = (window.milkitTranslations || {});
    var closeLabel = t.close || '';

    // Defaults/fallbacks for copy
    var heading = t.filterHeadlineHook || t.filterModalHeading || '';
    var intro = t.filterModalIntro || '';
    // Feature bullets removed
    var priceText = t.filterPriceText || '';

    var modal = document.createElement('div');
    modal.id = FILTER_MODAL_ID;
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-label', heading);
    modal.style.position = 'fixed';
    modal.style.inset = '0';
    modal.style.background = 'rgba(0,0,0,0.75)';
    modal.style.backdropFilter = 'blur(2px)';
    modal.style.display = 'none';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    modal.style.zIndex = '99999';

    var card = document.createElement('div');
    card.style.background = '#FFFFFF';
    card.style.borderRadius = '16px';
    card.style.width = 'min(520px, 92vw)';
    card.style.maxHeight = '80vh';
    card.style.overflow = 'hidden';
    card.style.boxShadow = '0 20px 60px rgba(0,0,0,0.3)';
    card.style.transform = 'translateY(20px) scale(0.95)';
    card.style.opacity = '0';
    card.style.transition = 'transform .35s cubic-bezier(0.19,1,0.22,1), opacity .35s ease';
    card.style.position = 'relative';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.textContent = '×';
    closeBtn.style.border = 'none';
    closeBtn.style.background = 'rgba(0,0,0,0.04)';
    closeBtn.style.width = '32px';
    closeBtn.style.height = '32px';
    closeBtn.style.borderRadius = '50%';
    closeBtn.style.fontSize = '20px';
    closeBtn.style.cursor = 'pointer';
    closeBtn.style.transition = 'all 0.2s';
    closeBtn.style.color = 'rgba(0,0,0,0.5)';
    closeBtn.style.display = 'flex';
    closeBtn.style.alignItems = 'center';
    closeBtn.style.justifyContent = 'center';
    closeBtn.style.lineHeight = '1';
    closeBtn.style.position = 'absolute';
    closeBtn.style.top = '12px';
    closeBtn.style.right = '12px';
    closeBtn.style.zIndex = '2';

    var body = document.createElement('div');
    body.style.padding = '20px 24px 36px';
    body.style.fontSize = '15px';
    body.style.lineHeight = '1.6';
    body.style.color = 'rgba(0,0,0,0.8)';
    body.style.maxHeight = 'calc(80vh - 0px)';
    body.style.overflowY = 'auto';

    var h2 = document.createElement('h2');
    h2.textContent = heading;
    h2.style.margin = '10px 0 10px';
    h2.style.fontSize = '22px';
    h2.style.textAlign = 'center';
    h2.style.fontWeight = '800';
    body.appendChild(h2);

    // Upsell badge line (use price as subtle badge)
    var upsellBadgeLine = document.createElement('div');
    var badge = (t.filterBadgePopular || '').trim();
    if (badge) {
      upsellBadgeLine.textContent = badge;
      upsellBadgeLine.style.margin = '0 auto 14px';
      upsellBadgeLine.style.textAlign = 'center';
      upsellBadgeLine.style.fontWeight = '600';
      upsellBadgeLine.style.fontSize = '14px';
      upsellBadgeLine.style.color = 'rgba(0,0,0,0.7)';
      body.appendChild(upsellBadgeLine);
    }

    // Intro (no included note)
    var introEl = document.createElement('div');
    var subtext = (t.filterSubtext || '').trim();
    introEl.innerHTML = [intro, subtext].filter(Boolean).map(function(s){ return '<div>' + s + '</div>'; }).join('');
    introEl.style.textAlign = 'center';
    introEl.style.margin = '0 0 12px';
    body.appendChild(introEl);

    // Feature grid removed

    // Visual image (single)
    var visuals = document.createElement('div');
    visuals.style.display = 'flex';
    visuals.style.alignItems = 'center';
    visuals.style.justifyContent = 'center';
    visuals.style.gap = '16px';
    visuals.style.margin = '12px 0 20px';
    visuals.style.padding = '12px 0';
    var filterImgUrl = (window.milkitAssets && (window.milkitAssets.detailsFilterImage || window.milkitAssets.filterImage)) || 'milk_it_filterkorb.webp';
    var imgWrap = document.createElement('div');
    imgWrap.className = 'media-wrapper media-wrapper--small';
    imgWrap.style.width = '200px';
    imgWrap.style.height = '200px';
    imgWrap.style.borderRadius = '12px';
    imgWrap.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)';
    
    var img = createLazyImageElement();
    img.src = filterImgUrl; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
    img.width = 200; img.height = 200;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    imgWrap.appendChild(img);
    wireThemeLoading(imgWrap, img);
    visuals.appendChild(imgWrap);
    body.appendChild(visuals);

    // CTA
    var ctaBtn = document.createElement('button');
    ctaBtn.type = 'button';
    var ctaText = (t.filterDetailsCtaEmotional || t.filterDetailsCta || '').trim();
    ctaBtn.textContent = ctaText;
    if (ctaText) ctaBtn.setAttribute('aria-label', ctaText);
    ctaBtn.style.background = '#000';
    ctaBtn.style.color = '#fff';
    ctaBtn.style.border = 'none';
    ctaBtn.style.borderRadius = '8px';
    ctaBtn.style.padding = '12px 20px';
    ctaBtn.style.fontWeight = '700';
    ctaBtn.style.fontSize = '15px';
    ctaBtn.style.cursor = 'pointer';
    ctaBtn.style.display = 'block';
    ctaBtn.style.margin = '10px auto 0';
    ctaBtn.addEventListener('click', function(){
      try {
        var filter = document.getElementById('milkit-filter-checkbox');
        if (filter) {
          filter.checked = true;
          filter.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Respect combined state
        if (window.MilkItVariantManager && typeof window.MilkItVariantManager.updateVariantFromCheckboxes === 'function') {
          window.MilkItVariantManager.updateVariantFromCheckboxes();
        } else if (window.MilkItVariantManager && typeof window.MilkItVariantManager.updateVariantBySku === 'function') {
          window.MilkItVariantManager.updateVariantBySku('milk_it_filter');
        }
      } catch (e) { /* no-op */ }
      filterClose();
    });
    body.appendChild(ctaBtn);
    // iOS Safari robustness: re-set text after DOM insertion
    if (!ctaBtn.textContent || ctaBtn.textContent.trim() === '') {
      setTimeout(function(){ ctaBtn.textContent = ctaText; }, 0);
    }

    // Social proof below CTA if available (no urgency)
    var proof = (t.filterSocialProof || '').trim();
    if (proof) {
      var below = document.createElement('div');
      below.style.fontSize = '12px';
      below.style.color = 'rgba(0,0,0,0.7)';
      below.style.textAlign = 'center';
      below.style.marginTop = '8px';
      below.textContent = proof;
      body.appendChild(below);
    }

    card.appendChild(closeBtn);
    card.appendChild(body);
    modal.appendChild(card);
    document.body.appendChild(modal);

    // Accent similar to EcoSeal
    var accent = document.createElement('div');
    accent.style.position = 'absolute';
    accent.style.top = '0';
    accent.style.right = '0';
    accent.style.width = '200px';
    accent.style.height = '200px';
    accent.style.background = 'radial-gradient(circle at top right, rgba(187, 255, 0, 0.08), transparent 70%)';
    accent.style.pointerEvents = 'none';
    accent.style.borderRadius = '0 16px 0 0';
    card.appendChild(accent);

    function filterOpen(){
      modal.style.display = 'flex';
      requestAnimationFrame(function(){
        card.style.transform = 'translateY(0) scale(1)';
        card.style.opacity = '1';
      });
      document.body.style.overflow = 'hidden';
    }
    function filterClose(){
      card.style.transform = 'translateY(20px) scale(0.95)';
      card.style.opacity = '0';
      setTimeout(function(){
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }

    // Expose
    window.milkitFilterDetailsModal = { open: filterOpen, close: filterClose };

    closeBtn.addEventListener('click', filterClose);
    modal.addEventListener('click', function(e){ if (e.target === modal) filterClose(); });
    document.addEventListener('keydown', function(e){ if (modal.style.display === 'flex' && e.key === 'Escape') filterClose(); });
  }

  function bindTrigger() {
    var trigger = document.querySelector(SELECTOR_TRIGGER);
    if (!trigger) return;
    trigger.addEventListener('click', function(){
      ensureModal();
      if (window.milkitDetailsModal) window.milkitDetailsModal.open();
    });
  }

  function bindFilterTrigger() {
    var trigger = document.querySelector(FILTER_SELECTOR_TRIGGER);
    if (!trigger) return;
    trigger.addEventListener('click', function(){
      ensureFilterModal();
      if (window.milkitFilterDetailsModal) window.milkitFilterDetailsModal.open();
    });
  }

  if (document.readyState !== 'loading') {
    ensureModal();
    ensureFilterModal();
    bindTrigger();
    bindFilterTrigger();
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      ensureModal();
      ensureFilterModal();
      bindTrigger();
      bindFilterTrigger();
    });
  }
})();
